import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

class CardCourse extends React.Component {
  render() {
    const {
      children,
      className,
      primaryTitle,
      featureTitle,
      image,
      secondaryTitle,
      onClick,
      onKeyPress,
      tag,
    } = this.props;

    const shouldShowTitlePlaceholder = !secondaryTitle && !primaryTitle;
    const onClickActions = onClick || onKeyPress ? {
      onClick,
      onKeyPress,
    } : { };

    return (
      <div
        className={`${classnames('CardCourse', className)}`}
        {...onClickActions}
      >
        <div className="CardCourse_container-img">
          {tag && <div className="CardCourse_container-tag">{tag}</div>}
          {image ? (
            <img
              className="CardCourse_card-img"
              src={image}
              alt=""
            />
          ) : (
            <div className="CardCourse_card-img-placeholder" />
          )}
          {!featureTitle ? null : (
            <div className="CardCourse_feature-label">
              <p>{featureTitle}</p>
            </div>
          )}
        </div>
        <div className="CardCourse_content">
          {shouldShowTitlePlaceholder ? null : (
            <div className="CardCourse_title">{secondaryTitle}</div>
          )}
          {shouldShowTitlePlaceholder ? null : (
            <div className="CardCourse_description">{primaryTitle}</div>
          )}
          {!shouldShowTitlePlaceholder ? null : (
            <div className="CardCourse_content-placeholder" />
          )}
        </div>
        {!children ? null : (
          <div className="CardCourse_children">{children}</div>
        )}
      </div>
    );
  }
}

CardCourse.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  primaryTitle: PropTypes.any,
  featureTitle: PropTypes.string,
  image: PropTypes.string,
  secondaryTitle: PropTypes.string,
  onClick: PropTypes.func,
  onKeyPress: PropTypes.func,
  tag: PropTypes.element,
};

CardCourse.defaultProps = {
  children: null,
  className: '',
  featureTitle: null,
  secondaryTitle: null,
  primaryTitle: null,
  image: null,
  onClick: null,
  onKeyPress: null,
  tag: null,
};

export default CardCourse;
